@if (cookieConsentAccepted === false) {
  <app-custom-cookie-consent (hideConsentPopup)="hideConsentPopup($event)"></app-custom-cookie-consent>
}
@if (updateEmailConsentPopup === true) {
  <app-update-email-consent (hideConsentPopup)="hideEmailConsentPopup($event)" (proceedAndHideConsentPopup)="proceedEmailUpdateAndHideConsentPopup($event)"></app-update-email-consent>
}

<div class="container main-container" [ngClass]="{responsive: showResponsive}">
  <div class="logo-img-container">
    <a class="logo-img-link" (click)="home()">
      <img src="assets/images/diversey-logo-new.png" class="logo-img">
    </a>
    <span class="site-name">Internet of Clean</span>
  </div>
  @if (name && (solutionName != 'portal-admin')) {
    <div class="client-logo-holder">
      <!--<div *ngIf="!clientLogo"  class="no-logo">Client Logo</div>-->
      @if (clientLogo) {
        <img src="{{clientLogo}}" onerror="this.onerror=null;this.src='assets/images/nologo.png'" />
      }
    </div>
  }
  @if (!name) {
    <div class="logo-text-container flex-col flex-ai-end">
      <span class="logo-text">Digital Portal</span>
    </div>
  }
  @if (name) {
    <div class="user-info-container flex-row">
      <div class="user-greeting flex-row" [ngClass]="{dropdown: !showResponsive}">{{'hello' | translate}}
        <span class="username" (click)="toggleDropdown($event)">{{name}}</span>
        <span [ngClass]="toggle ? 'arrowUp' : 'arrowDown'" (click)="toggleDropdown($event)"></span>
        <ul class="dropdown-menu" [style.display]="toggle ? 'block' : 'none'">
          <li class="dropdown-item" (click)="openUserProfile()">
            <a class="item-link">
              <span class="item-text">{{'profile' | translate}}</span>
            </a>
          </li>
          <li class="dropdown-item" (click)="changePassword()">
            <a class="item-link">
              <span class="item-text">{{'change_password' | translate}}</span>
            </a>
          </li>
          @if (isSolenisMigrationEmail && !checkDiverseyRootOrPowerAdmin()) {
            <li class="dropdown-item" (click)="updateEmail()">
              <a class="item-link">
                <span class="item-text"> Update Email </span>
              </a>
            </li>
          }
          @if (showHideDeactivateBtn()) {
            <li class="dropdown-item" (click)="showDeactivateModal()">
              <a class="item-link">
                <span class="item-text">{{'deactivate_account' | translate}}</span>
              </a>
            </li>
          }
          <li class="dropdown-item" (click)="modifyCookies()">
            <a class="item-link">
              <span class="item-text">{{'modify_cookies' | translate}}</span>
            </a>
          </li>
          <li class="dropdown-item" (click)="logout()">
            <a class="item-link">
              <span class="item-text">{{'logout' | translate}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="flag-container">
        <img class="flag" src="assets/images/flags/{{flagIcon}}.svg" title="{{countryName}}" alt="{{countryName}}">
      </div>
    </div>
  }
</div>


<!-- User Profile Popup-->
@if (showUserProfile) {
  <app-popup (isProfileTab)="switchTabs($event)" [isProfileTabActive]="showtab" [isDeactivateTabActive]="showDeactivatetab" [isUpdateEmailTab]="showUpdateEmailTab" [isAdminUser]="showHideDeactivateBtn()" (closeSelf)="closeUserProfile($event)" (click)="closeUserProfile()">
    @if (showtab) {
      <user-profile (notify)="closeUserProfile()"></user-profile>
    }
    @if (!showtab && !showDeactivatetab && !showUpdateEmailTab) {
      <app-reset-password (notify)="closeUserProfile()"></app-reset-password>
    }
    @if (!showtab && showDeactivatetab && !showUpdateEmailTab) {
      <deactivate-account (notify)="closeUserProfile()"></deactivate-account>
    }
    @if (!showtab && !showDeactivatetab && showUpdateEmailTab) {
      <app-update-email (notify)="closeUserProfile()"></app-update-email>
    }
  </app-popup>
}
@if (conditionsAccepted === false) {
  <app-terms-conditions-acceptance (updateTerms)="showPopUp($event)" [isLoading]="isLoaded">
    <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block; max-width: 100%; height: 100vh;" [autoresize]="false" [original-size]="true" [fit-to-page]="true" (after-load-complete)="afterLoadComplete($event)" (on-progress)="onProgress($event)" (error)="onError($event)"></pdf-viewer>
    @if (!isLoaded) {
      <div class="site-loader-wrapper">
        <div class="loader"></div>
      </div>
    }
  </app-terms-conditions-acceptance>
}